import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import CcEmailsInput from './CcEmailsInput';
import './SaveSearchModal.css';

const EMAIL_FREQUENCY_OPTIONS = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'never', label: 'Never' }
];

const FREQUENCY_HINTS = {
    daily: "You'll receive a daily email with new matching properties.",
    weekly: "You'll receive a weekly email digest every Monday.",
    monthly: "You'll receive a monthly email digest on the 1st.",
    never: "You won't receive email notifications for this search."
};

const SaveSearchModal = ({ isOpen, onClose, onSave }) => {
    const [name, setName] = useState('');
    const [emailFrequency, setEmailFrequency] = useState('daily');
    const [error, setError] = useState('');
    const [ccEmails, setCcEmails] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name.trim()) {
            setError('Please enter a name for your search.');
            return;
        }
        onSave({ name, email_frequency: emailFrequency, cc_emails: ccEmails });
        setName('');
        setEmailFrequency('daily');
        setCcEmails([]);
        setError('');
    };

    const handleClose = () => {
        setName('');
        setEmailFrequency('daily');
        setCcEmails([]);
        setError('');
        onClose();
    };

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal-content save-search-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Save Search</h2>
                    <button className="close-button" onClick={handleClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit} className="modal-body">
                    <p className="modal-description">
                        Save your current filters and get notified about new matching properties.
                    </p>

                    <div className="form-group">
                        <label className="form-label">Name your search</label>
                        <input
                            type="text"
                            className="search-name-input"
                            placeholder="e.g., Warren Fixer Uppers"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            autoFocus
                        />
                        {error && <p className="error-message">{error}</p>}
                    </div>

                    <div className="form-group">
                        <label className="form-label">Email frequency</label>
                        <select
                            className="email-frequency-select"
                            value={emailFrequency}
                            onChange={(e) => setEmailFrequency(e.target.value)}
                        >
                            {EMAIL_FREQUENCY_OPTIONS.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                        <p className="form-hint">
                            {FREQUENCY_HINTS[emailFrequency]}
                        </p>
                    </div>

                    <div className="form-group">
                        <CcEmailsInput
                            value={ccEmails}
                            onChange={setCcEmails}
                            inputClassName="search-name-input"
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="btn-secondary" onClick={handleClose}>Cancel</button>
                        <button type="submit" className="btn-primary">Save Search</button>
                    </div>
                </form>
            </div>
        </div>,
        document.body
    );
};

export default SaveSearchModal;
